import * as p from '@clack/prompts'
import path from 'node:path'
import type { ListPresetsCommandOptions } from '@cli-types/core-engine/commands.js'
import { renderTableRows } from '@cli-utils/terminal.js'
import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'
import { resolveConfig } from '@next-adapter/config/resolve-config.js'
import { listAvailablePresets } from '@next-adapter/preset-runtime/list-available-presets.js'

export async function runListPresetsCommand(options: ListPresetsCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()

  if (options.json) {
    let installed: Set<string>
    try {
      installed = new Set((await resolveConfig(cwd)).presets.installed)
    } catch (error) {
      console.error(
        `Error loading config: ${error instanceof Error ? error.message : String(error)}`
      )
      process.exit(1)
    }
    const items = listAvailablePresets().map((preset) => ({
      id: preset.id,
      status: installed.has(preset.id) ? 'installed' : 'available',
      kind: preset.kind,
      description: preset.description
    }))
    console.log(JSON.stringify(items, null, 2))
    return
  }

  const config = await resolveConfigOrExit(cwd)
  const installedPresets = new Set(config.presets.installed)

  const rows = listAvailablePresets().map((preset) => [
    preset.id,
    installedPresets.has(preset.id) ? 'installed' : 'available',
    preset.kind,
    preset.description
  ])

  p.note(renderTableRows(rows).join('\n'), 'BetterStart presets')
  p.outro(`${installedPresets.size} installed, ${rows.length - installedPresets.size} available`)
}
